import { Timestamp } from "@angular/fire/firestore";

export class NotificationRequest {
  id!: string;
  body!: string;
  status!: 'UNREAD' | 'READ' | 'ARCHIVED' | 'DELETED';
  title!: string;
  type!:
    | 'NEW_JOB_POSTED'
    | 'APPLICATION_RECEIVED'
    | 'APPLICATION_PENDING'
    | 'APPLICATION_REVIEWED'
    | 'APPLICATION_ACCEPTED'
    | 'APPLICATION_REJECTED'
    | 'APPLICATION_STATUS_UPDATE'
    | 'APPLICATION_DELETED'
    | 'ACCOUNT_APPROVED'
    | 'ACCOUNT_REJECTED'
    | 'MESSAGE'
    | 'SYSTEM'
    | 'NEW_ARTICLE'
    | 'PUBLIC_ANNOUNCEMENT'
    | 'NEW_USER_REGISTERED'
    | 'COMMENT'
    | 'REPLY'
    | 'PASSWORD_RESET'
    | 'LOGIN'
    | 'COURSE_APPLICATION_RECEIVED'
    ;
  userIds!: Array<string>;
  timestamp!: Timestamp;
  isOpen: boolean = false;
  isNew?: boolean;
}